import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'

type FormCardSkeletonProps = {
  fields?: number
  /**
   * Merged over the card's own classes (tailwind-merge, so `max-w-none` drops
   * the default cap). Use it to match a form that isn't `max-w-2xl` wide.
   */
  className?: string
}

export function FormCardSkeleton({ fields = 5, className }: FormCardSkeletonProps) {
  return (
    <div
      className={cn(
        'rounded-2xl bg-white shadow-[48px_27px_74px_0px_rgba(0,0,0,0.12)] p-6 max-w-2xl',
        className,
      )}
    >
      <div className="space-y-6">
        {Array.from({ length: fields }).map((_, i) => (
          <div key={i} className="space-y-2">
            <Skeleton className="h-4 w-32 rounded" />
            <Skeleton className="h-10 w-full rounded-md" />
          </div>
        ))}
        <Skeleton className="h-10 w-32 rounded-md" />
      </div>
    </div>
  )
}
